module.exports = __webpack_public_path__ + "files/SPIADI2023 - Rapport national OBSERVA4 - juillet 2024.fbebc39c16394a86dd0c3ea0b39749c5.pdf";